// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".dynamic-asset-select .dynamic-toggle{\n\tborder-right: none;\n\twidth: 30px;\n\theight: 30px;\n\n}\n", "",{"version":3,"sources":["DynamicAssetSelect.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;;AAEb","file":"DynamicAssetSelect.css","sourcesContent":[".dynamic-asset-select .dynamic-toggle{\n\tborder-right: none;\n\twidth: 30px;\n\theight: 30px;\n\n}\n"]}]);
// Exports
module.exports = exports;
